module.exports = __webpack_public_path__ + "images/img_2_3-0a2b927c49.png";